// ─────────────────────────────────────────────────────────────────────────────
// Logo oturum yonetimi. /api/session/* uclari.
// Oturum sunucu tarafinda cerezle tutulur; client.ts withCredentials ile tasir.
// ─────────────────────────────────────────────────────────────────────────────

import { logoRequest } from './client';
import { logoConfig } from '../config';
import { LogoLoginRequest, LogoResult, LogoSessionStatus } from '../types';

let lastStatus: LogoSessionStatus | null = null;

/** POST /api/session/login — config'teki bilgilerle (veya override ile) oturum acar. */
export async function login(creds?: Partial<LogoLoginRequest>): Promise<LogoResult<LogoSessionStatus>> {
  const body: LogoLoginRequest = {
    username: creds?.username ?? logoConfig.login.username,
    password: creds?.password ?? logoConfig.login.password,
    firmaNo: creds?.firmaNo ?? logoConfig.login.firmaNo,
  };
  const res = await logoRequest<LogoSessionStatus>({ url: '/api/session/login', method: 'POST', data: body });
  if (res.ok && res.data) lastStatus = res.data;
  return res;
}

/** POST /api/session/logout */
export async function logout(): Promise<LogoResult<void>> {
  const res = await logoRequest<void>({ url: '/api/session/logout', method: 'POST' });
  if (res.ok) lastStatus = null;
  return res;
}

/** GET /api/session/status */
export async function getStatus(): Promise<LogoResult<LogoSessionStatus>> {
  const res = await logoRequest<LogoSessionStatus>({ url: '/api/session/status', method: 'GET' });
  if (res.ok && res.data) lastStatus = res.data;
  return res;
}

/** Bilinen son durum (cagri yapmadan). */
export function currentSession(): LogoSessionStatus | null {
  return lastStatus;
}

/**
 * Oturum yoksa otomatik login dener. Diger api fonksiyonlari cagri oncesi
 * bunu kullanabilir; boylece UI'da tek tek login yonetmeye gerek kalmaz.
 */
export async function ensureSession(): Promise<boolean> {
  if (lastStatus?.connected) return true;
  const status = await getStatus();
  if (status.ok && status.data?.connected) return true;
  const res = await login();
  return res.ok && !!res.data?.connected;
}
